import { Box, Typography } from '@mui/material';

import { BRAND_NAME } from '@/constants/brand';

/**
 * The site's copyright line — the one place the legal owner and the current year are stated.
 *
 * Exported separately from `Footer` so the landing page's own footer (which has link columns above
 * it, and so cannot nest a second `<footer>` element) prints the identical line instead of a second
 * copy of the same string.
 *
 * The brand comes from `BRAND_NAME`, not a literal: this line was the last visible place still
 * rendering the old `Willnq` casing after the brand was normalised, and it sits directly under the
 * `WillnQ` wordmark in the landing footer, where the mismatch was plain to see.
 */
export function Copyright() {
  return (
    <Typography variant="caption" color="text.secondary">
      {BRAND_NAME} © {new Date().getFullYear()} Raga Tech Source Pvt Ltd
    </Typography>
  );
}

export function Footer() {
  return (
    <Box component="footer" sx={{ py: 2, px: 3, textAlign: 'center' }}>
      <Copyright />
    </Box>
  );
}
